import { defineRule, configure } from 'vee-validate'
import AllRules from '@vee-validate/rules'
import { localize, setLocale } from '@vee-validate/i18n'
import store from '@/store'

type AppLang = 'ja' | 'en'

// webpack が JSON を解決する。型定義が無いため require で読み込む
/* eslint-disable @typescript-eslint/no-var-requires */
const en = require('@vee-validate/i18n/dist/locale/en.json')
const ja = require('@vee-validate/i18n/dist/locale/ja.json')
/* eslint-enable @typescript-eslint/no-var-requires */

// TODO Vue3 update とりあえず全部追加する
Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule as keyof typeof AllRules])
})

// 小数点チェックのカスタムルール
defineRule('decimal', (value, params, meta) => {
  const paramList = params as string[] | number[]
  const numbers = String(value).split('.')
  const checkLength = Number(paramList[0]) || 0
  const message: Record<AppLang, string> = {
    ja: `${meta.field}は小数第${paramList[0]}位以内で入力してください`,
    en: `Please enter ${meta.field} to the decimal ${paramList[0]} place`,
  }

  if (!numbers[1] || numbers[1].length <= checkLength) {
    return true
  }

  const lang = store.getters['app/langInfo'] as AppLang
  return message[lang]
})

configure({
  generateMessage: localize({
    en,
    ja,
  }),
})

setLocale(store.getters['app/langInfo'])
